/* Built In Imports */
import { useContext, useEffect } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import PageConfig from '@msr/Common/PageConfig';
import ShivaTopic from '@msr/components/Card/ShivaTopic';
import ShivaTopicContent from '@msr/components/Card/ShivaTopicContent';
import MsrTopicBanner from '@msr/components/HeaderBanner/MsrTopicBanner';
import MsrSectionTitle from '@msr/components/Headings/MsrSectionTitle';
import WrapLayout from '@msr/components/Layout/WrapLayout';
import Breadcrum from '@msr/components/Navigation/Breadcrum';
import { AuthContext } from '@store/auth-context';

/* Services */
import { getLocale } from '@msr/components/Utility/Shared/SharedService';
import {
    fetchFooterDetailData,
    fetchHeaderMenuData,
} from 'services/commonService';
import { fetchDetails, getLandingPaths } from 'services/msrService';

/**
 *
 * @param pageData.pageData
 * @param {object} pageData
 * @param pageData.lang
 * @returns
 */
const ShivaBlogTopicLang = ({ pageData, lang }) => {
  const authContext = useContext(AuthContext);

  useEffect(() => {
    authContext.RegionAndLang('', lang);
  }, [authContext, '', lang]);

  return (
    <WrapLayout pageData={pageData}>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData.availableLocales}
      >
        {' '}
      </HeadComponent>
      <Breadcrum
        page={pageData.breadcrumbs}
        alsoin={pageData.alsoin}
        url=""
        region={''}
        lang={lang}
      />
      <Box as="section" className="container-article">
        <MsrTopicBanner
          sectionContent={pageData?.pageContent}
          pageData={pageData}
        />
        <ShivaTopicContent
          shivaPosts={pageData?.posts}
          topic={pageData?.title}
          lang={lang}
        />
        <Box maxW="1140px" m="30px auto">
          <MsrSectionTitle
            titleObj={{
              titleDecoration: 'white-no-decoration',
              titleSubtext: '',
              titleText: pageData?.pageContent?.json?.exploreTitle,
            }}
            mt="0"
            mb="0"
          />
          <ShivaTopic topics={pageData?.topics} lang={lang} />
        </Box>
      </Box>
      <PageConfig isLikeVisible={false} pageData={pageData} />
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  const msrPaths = config.USE_LOCAL_URL
    ? [
        `/mahashivratri/ta/shiva/topic/adiyogi`,
        `/mahashivratri/ta/shiva/topic/shiva`,
        `/mahashivratri/kn/shiva/topic/mysticism/`,
      ]
    : await getLandingPaths('L3', '/shiva/topic/', 'shiva_topic');
  return {
    paths: msrPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { lang, topic },
}) => {
  const headerMenuData = await fetchHeaderMenuData(
    getLocale('', lang, 'msr'),
    'msrmainmenu'
  );
  const footerData = await fetchFooterDetailData(
    getLocale('', lang, 'msr'),
    'msrfooter'
  );
  const pageData = await fetchDetails('', lang, `shiva/topic/${topic}`, {
    preview,
    data: previewData,
  });

  return {
    props: {
      headerMenuData: headerMenuData?.data || null,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      isPreview: preview ? true : false,
      lang: lang,
      menuType: 'msrmainmenu',
    },
  };
};

export default ShivaBlogTopicLang;
